import { Suspense } from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import * as Sentry from '@sentry/react';
//
import { install } from "resize-observer";
import App from './App';

install();

declare global {
  interface Window {
    mathVirtualKeyboard: any;
  }
}

// ----------------------------------------------------------------------
if (process.env.NODE_ENV === 'production') {
  Sentry.init({
    dsn: "https://129e13f9931d1610eca7cb78b7585b14@o4505680983228416.ingest.sentry.io/4505680984539136",
    integrations: [
      new Sentry.BrowserTracing({
        // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
        tracePropagationTargets: ["localhost", "https://api.matemati.co"],
      }),
      new Sentry.Replay({
        maskAllText: false,
        blockAllMedia: false
      }),
    ],
    // Performance Monitoring
    tracesSampleRate: 1.0, // Capture 100% of the transactions, reduce in production!
    // Session Replay
    replaysSessionSampleRate: 1.0, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
    replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
  });
}


const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);

root.render(
  <HelmetProvider>
    <BrowserRouter>
      <Suspense>
        <App />
      </Suspense>
    </BrowserRouter>
  </HelmetProvider>
);
